var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenSquigle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7355 14.6769C28.1976 11.0204 29.9606 7.46768 29.5802 4.89451C29.4013 3.68515 28.7327 2.77171 27.6975 2.32248C25.5392 1.38565 21.1488 2.28478 15.8295 7.85718C13.5373 2.4324 11.0488 -0.669936 9.60544 0.122682C8.31031 0.833086 8.43584 4.32333 9.91777 9.28661C4.70183 6.21653 0.780278 5.21065 0.0996732 6.7918C-0.547151 8.29414 1.98753 11.3109 6.73202 14.7062C2.55517 16.6153 0.35903 19.0156 0.841748 21.1679C1.39904 23.6539 5.59804 25.2798 12.5612 23.6278C12.8984 29.8236 14.8133 32.7327 16.4715 32.8117C16.4975 32.8128 16.5232 32.8133 16.549 32.8133C17.8513 32.813 18.9035 31.2353 19.5016 28.4748L19.6259 21.1638C27.0348 23.1983 31.7226 23.2442 32.204 21.2719C32.6166 19.5834 29.6937 17.0093 24.7355 14.6769Z",
    fill: "#6ECCA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSquigle);
export default __webpack_public_path__ + "static/media/green_squigle.18d5f50f2c6cf192a458c626655ea609.svg";
export { ForwardRef as ReactComponent };